import { render, staticRenderFns } from "./AdviceText.vue?vue&type=template&id=2b83d476&scoped=true&"
import script from "./AdviceText.vue?vue&type=script&lang=js&"
export * from "./AdviceText.vue?vue&type=script&lang=js&"
import style0 from "./AdviceText.vue?vue&type=style&index=0&id=2b83d476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83d476",
  null
  
)

export default component.exports